import ApiUrl from "../../configTools/apiUrl";

const CreateProductChangeType = (v,setSizesList,setSizesFilter,setSizes,setType) =>{
    fetch(ApiUrl.API_URL_ListingType+"/"+v.value)
    .then(res=>res.json())
    .then(data =>{
        let sizeListSend = [];
        for (let index = 0; index < data.sizeList.length; index++) {
          const element = data.sizeList[index];
          sizeListSend.push({
            name: element.name,
            value: String(element.id)
          })
        }
        setSizesList(sizeListSend);
        setSizesFilter(sizeListSend);
    });
    setSizes([]);
    setType(v);
}

const Get = (setValues)=>{
    fetch(ApiUrl.API_URL_ListingType)
    .then(res=>res.json())
    .then(data =>{
        let listingTypeListSend = [];
        for (let index = 0; index < data.length; index++) {
            const element = data[index];
            listingTypeListSend.push({
            name: element.name,
            value: String(element.id)
            })
        }
        setValues(listingTypeListSend);
    });
}


export default {CreateProductChangeType,Get}